export default __webpack_public_path__ + "click-the-floating-button.png";